<template>
    <div class="course-type-page">
        <div class="course-top">
            <van-swipe class="top-swipe" :autoplay="3000" :show-indicators="false" @change="onSwipeChange">
                <van-swipe-item v-for="(item, index) in bannerList" :key="index">
                    <div class="top-banner" :style="{ backgroundImage: 'url(' + item + ')' }"></div>
                </van-swipe-item>
                <div class="custom-indicator" slot="indicator">
                    <span
                        v-for="(item, index) in bannerList"
                        :key="`indicator-${index}`"
                        :class="['indicator-dot', { active: index === currentSwipe }]"
                    ></span>
                </div>
            </van-swipe>
        </div>

        <div class="content-wrap">
            <div class="section-title">{{ typeName }}</div>
            <div class="list-card">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="loadCourseList"
                >
                    <div
                        class="course-item"
                        v-for="(item, index) in list"
                        :key="item.id || index"
                        @click="openDetail(item)"
                    >
                        <div
                            class="course-cover"
                            :style="item.cover ? { backgroundImage: 'url(' + item.cover + ')' } : null"
                        ></div>
                        <div class="course-body">
                            <div class="course-title">{{ item.title }}</div>
                            <div class="course-footer">
                                <span class="course-date">{{ item.createTime }}</span>
                                <span :class="['read-tag', item.isTrain === '已培训' ? 'read' : 'unread']">
                                    <img class="tag-icon" :src="seeIcon" alt="">
                                    <span class="tag-text">{{ item.isTrain || '未培训' }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </van-list>
            </div>
        </div>
    </div>
</template>

<script>
import { getBannerList, getCourseList } from '@/api/index.js';

const defaultBannerImg = require('@/assets/image/evaluation-top-bg.png');

export default {
    name: 'CourseTypeList',
    data() {
        return {
            currentSwipe: 0,
            seeIcon: require('@/assets/image/see-icon.png'),
            bannerList: [defaultBannerImg],
            list: [],
            loading: false,
            finished: false,
            pageNum: 1,
            pageSize: 20
        };
    },
    computed: {
        typeId() {
            return this.$route.query.typeId || '';
        },
        typeName() {
            return this.$route.query.typeName || '分类名称';
        }
    },
    created() {
        this.loadBannerList();
    },
    methods: {
        onSwipeChange(index) {
            this.currentSwipe = index;
        },
        loadBannerList() {
            getBannerList({
                type: '课程学习'
            })
                .then(res => {
                    const records = Array.isArray(res?.data?.records) ? res.data.records : [];
                    const urls = records.map(item => item.img).filter(Boolean);
                    this.bannerList = urls.length > 0 ? urls : [defaultBannerImg];
                })
                .catch(() => {
                    this.bannerList = [defaultBannerImg];
                });
        },
        loadCourseList() {
            if (!this.typeId) {
                this.finished = true;
                this.loading = false;
                return;
            }
            getCourseList({
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                typeId: this.typeId
            })
                .then(res => {
                    const data = res?.data || {};
                    const records = data.records || [];
                    this.list = this.list.concat(records);
                    const total = Number(data.total || 0);
                    this.finished = this.list.length >= total || records.length < this.pageSize;
                    this.pageNum += 1;
                })
                .catch(() => {
                    this.finished = true;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        openDetail(item) {
            this.$router.push({ name: 'courseDetail', query: { id: item.id } });
        }
    }
};
</script>

<style scoped lang="scss">
.course-type-page {
    min-height: 100%;
    display: flex;
    flex-direction: column;
}

.course-top {
    flex-shrink: 0;
    width: 100%;
    height: 300px;
    background: #fff;
}

.top-swipe {
    width: 100%;
    height: 300px;
    overflow: hidden;
    position: relative;
}

.top-banner {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
}

.custom-indicator {
    position: absolute;
    left: 50%;
    bottom: 90px;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: 8px;
}

.indicator-dot {
    width: 30px;
    height: 4px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.55);
}

.indicator-dot.active {
    background: #fff;
}

.content-wrap {
    flex: 1;
    padding: 20px 15px 80px;
    margin-top: -80px;
    position: relative;
    z-index: 2;
    background: linear-gradient(to bottom, #c2e5eb, #eef4f5);
    border-radius: 20px 20px 0 0;
}

.section-title {
    font-size: 22px;
    font-weight: 700;
    color: #333;
    margin-bottom: 10px;
}

.list-card {
    background: #fff;
    border-radius: 12px;
    padding: 12px;
}

.course-item {
    display: flex;
    gap: 12px;
    padding-bottom: 12px;
    margin-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;
}

.course-item:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
}

.course-cover {
    width: 110px;
    height: 80px;
    border-radius: 8px;
    background: linear-gradient(120deg, #89d9f7, #6b8cff);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    flex-shrink: 0;
}

.course-body {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.course-title {
    font-size: 15px;
    font-weight: 600;
    color: #333;
    line-height: 1.35;
    margin-bottom: 8px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-all;
}

.course-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.course-date {
    font-size: 11px;
    color: #9c9c9c;
}

.read-tag {
    display: inline-flex;
    align-items: center;
    height: 24px;
    border-radius: 4px;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.read-tag.read {
    background-image: url('~@/assets/image/read-icon.png');
}

.read-tag.unread {
    background-image: url('~@/assets/image/unread-icon.png');
}

.tag-icon {
    width: 24px;
    height: 24px;
    padding: 5px;
    box-sizing: border-box;
    object-fit: contain;
    flex-shrink: 0;
}

.tag-text {
    padding: 0 8px;
    font-size: 12px;
    line-height: 24px;
    font-weight: 500;
}

.read .tag-text {
    color: #46CCDC;
}

.unread .tag-text {
    color: #FF7A00;
}
</style>
